/**
 * 腾讯广告 → 广告命名模板（CLAUDE.md §pages/<domain> 薄壳；PR-AT-20260626-004）。
 *
 * 编辑器主体见 components/adNameTemplate/AdNameTemplateEditor.tsx（跨平台共享），
 * 本页只注入腾讯域差异：腾讯 API 服务、腾讯权限 key、腾讯默认空白模板、
 * 「3 项组合」红线特例字段提示。
 *
 * 页面底部挂「策略配置 × 二级策略 合法映射」编辑器（可编辑保存，单例配置）：
 * 选项从上方模板的「策略配置」/「二级策略」字段枚举拉取，保存后红线
 * check_ad_name() 即按新映射校验（2026-10-16 红线映射校验需求，详见
 * docs/tencent/需求变更摘要_20261016_广告命名策略映射校验.md）。
 *
 * UI 规范：已读 docs/frontend_ui_guidline/leo-frontend-design.md v1.0，
 * 适用 §2 设计 Token / §3.2 字号阶梯 / §6.4 卡片。
 */

import { AdNameTemplateEditor } from "../../components/adNameTemplate/AdNameTemplateEditor";
import { StraSecondMappingEditor } from "../../components/adNameTemplate/StraSecondMappingEditor";
import {
  getLatestTemplate,
  saveTemplate,
} from "../../services/tencent/adNameTemplate";
import { newBlankTemplate } from "../../utils/adNameTemplateFactory";
import { PAGE_KEYS } from "../../config/permissions";
import { useAuth } from "../../contexts/AuthContext";

/** 命名模板中支持「3 项组合」的字段名集合。
 *  与后端 src.tencent.services.redline.redline#get_aom_adname_config 的 combos_cnt=3 分支对齐：
 *  这些字段的枚举值可配置在「枚举组1」或「枚举组2」中均可，校验时取两组并集生成 1/2/3 项组合。 */
const THREE_COMBO_FIELDS: ReadonlySet<string> = new Set(["利益点", "专项"]);

export default function AdNameTemplatePage() {
  const { canEdit } = useAuth();
  return (
    <>
      <AdNameTemplateEditor
        pageKey={PAGE_KEYS.TENCENT_AD_NAME_TEMPLATE}
        fetchLatest={getLatestTemplate}
        save={saveTemplate}
        createBlankTemplate={newBlankTemplate}
        threeComboFields={THREE_COMBO_FIELDS}
      />
      <div className="mx-auto max-w-[1200px] px-6 pb-9 md:px-10 lg:px-14">
        <StraSecondMappingEditor
          readOnly={!canEdit(PAGE_KEYS.TENCENT_AD_NAME_TEMPLATE)}
        />
      </div>
    </>
  );
}
